import moment from 'moment';

/**
 * Checks if a given date range lies within the first week of the month and includes a Saturday.
 * @param {string} fromDate - The start date in "MM/DD/YYYY" format.
 * @param {string} toDate - The end date in "MM/DD/YYYY" format.
 * @returns {boolean} - True if both conditions are met, false otherwise.
 */
const isDateRangeInFirstWeekWithSaturday = (fromDate, toDate) => {
  const startDate = moment (fromDate, 'MM/DD/YYYY');
  const endDate = moment (toDate, 'MM/DD/YYYY');

  if (
    !startDate.isValid () ||
    !endDate.isValid () ||
    !endDate.isSameOrAfter (startDate, 'day')
  ) {
    return false;
  }

  // First week = 1st to 7th of the month
  const firstWeekStart = startDate.clone ().startOf ('month');
  const firstWeekEnd = firstWeekStart.clone ().add (6, 'days');

  const isInFirstWeek =
    startDate.isSameOrAfter (firstWeekStart, 'day') &&
    endDate.isSameOrBefore (firstWeekEnd, 'day');

  // Check for Saturday in the range
  let hasSaturday = false;
  const current = startDate.clone ();
  while (current.isSameOrBefore (endDate, 'day')) {
    if (current.day () === 6) {
      hasSaturday = true;
      break;
    }
    current.add (1, 'day');
  }

  return isInFirstWeek && hasSaturday;
};

const getFirstWeekSaturdays = year => {
  const result = {};

  for (let month = 0; month < 12; month++) {
    for (let day = 1; day <= 7; day++) {
      const date = moment ({year, month, day});
      if (date.day () === 6) {
        result[date.format ('MMMM')] = date.format ('MM/DD/YYYY');
        break;
      }
    }
  }

  return result;
};
const isWorkingSaturday = date => {
  if (date.day () !== 6) return false; // Not Saturday

  const firstDayOfMonth = date.clone ().startOf ('month');
  let firstSaturday = firstDayOfMonth.clone ();

  while (firstSaturday.day () !== 6) {
    firstSaturday.add (1, 'day');
  }

  return date.isSame (firstSaturday, 'day');
};

export {
  isDateRangeInFirstWeekWithSaturday,
  getFirstWeekSaturdays,
  isWorkingSaturday,
};
